import { confirmDialogActionsCreator } from "../../components/Dialogs/ConfirmDialog/state/confirmDialogActionsCreator";

export const dialogsActionsCreator = () => {
  return {
    confirm: confirmDialogActionsCreator(),
  };
};
